import { queryOptions } from '@tanstack/react-query';

import { getAccessToken } from '@/lib/tokenStorage';

import type { StringMapItem } from './types';

function getBaseUrl(): string {
  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
  if (
    !API_BASE_URL ||
    API_BASE_URL === 'undefined' ||
    API_BASE_URL === 'null'
  ) {
    throw new Error('VITE_API_BASE_URL is not defined or invalid');
  }
  return API_BASE_URL;
}

function getHeaders(): HeadersInit {
  const token = getAccessToken();
  if (!token) {
    throw new Error('No access token available. Please log in.');
  }
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

export async function fetchStringMap(
  objectTypeCode: number,
  name: string,
): Promise<StringMapItem[]> {
  const params = new URLSearchParams();
  params.set('objectTypeCode', String(objectTypeCode));
  params.set('name', name);
  const url = `${getBaseUrl()}/api/v1/lookups/string-map?${params.toString()}`;
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: getHeaders(),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return (await response.json()) as StringMapItem[];
}

export const stringMapOptions = (objectTypeCode: number, name: string) =>
  queryOptions({
    queryKey: ['lookups', 'string-map', objectTypeCode, name],
    queryFn: () => fetchStringMap(objectTypeCode, name),
  });
